import { useAuth } from '@/shared/auth/AuthContext'
import type { ModuleKey } from '@/shared/api/types'
import { MODULE_LABELS } from '@/shared/format'
import { Card, EmptyState, Note } from '@/shared/ui/primitives'

/**
 * Écran d'un module déclaré côté back (`ModuleKey`) mais sans API.
 * On ne montre PAS de données fictives sur une console connectée : une
 * valeur inventée dans le même écran qu'une valeur réelle n'est plus
 * distinguable, et c'est précisément ce que ce produit doit interdire.
 */
export function ModulePendingPage({ module, scope }: { module: ModuleKey; scope: string }) {
  const { hasModule } = useAuth()
  const label = MODULE_LABELS[module] ?? module
  return (
    <>
      {!hasModule(module) && (
        <Note tone="warn" title="Module non souscrit">
          Le module « {label} » n'est pas activé pour ce locataire.
        </Note>
      )}
      <Card>
        <EmptyState
          icon="clock"
          title={`${label} — en attente d'API`}
          message={`Le module est prévu au contrat (clé \`${module}\`) mais le back n'expose pas encore de routes pour ${scope}. L'écran sera branché dès qu'elles existeront ; aucune donnée fictive n'est affichée ici.`}
        />
      </Card>
    </>
  )
}
